import { render, staticRenderFns } from "./CoverageFormulaValidation.vue?vue&type=template&id=37ad34ea&scoped=true"
import script from "./CoverageFormulaValidation.vue?vue&type=script&lang=js"
export * from "./CoverageFormulaValidation.vue?vue&type=script&lang=js"
import style0 from "./CoverageFormulaValidation.vue?vue&type=style&index=0&id=37ad34ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37ad34ea",
  null
  
)

export default component.exports